import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('body');

import { IModalBoxAdapterProps } from './ModalBox.types';

const ModalBoxAdapter = ({
  className,
  children,
  handleCloseModal,
  open,
}: IModalBoxAdapterProps): JSX.Element => {
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;

  return (
    <Modal
      bodyOpenClassName="prevent-scroll"
      className={contentClassName}
      isOpen={open}
      onRequestClose={handleCloseModal}
      overlayClassName={overlayClassName}
      portalClassName={className}
      shouldCloseOnOverlayClick={true}
    >
      {children}
    </Modal>
  );
};

export default ModalBoxAdapter;
